<template>
  <div class="user-sign-table">
    <el-table border :data="userSignList">
      <el-table-column type="index" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="name" label="标签名称" align="center">
      </el-table-column>
      <el-table-column prop="signType" label="分类" align="center">
      </el-table-column>
      <el-table-column prop="channel" label="渠道" align="center">
      </el-table-column>
      <el-table-column prop="countryCode" label="国家" align="center">
      </el-table-column>
      <el-table-column prop="signTemplate" label="模板" align="center">
      </el-table-column>
      <el-table-column prop="signTemplate" label="内容" align="center">
      </el-table-column>
      <el-table-column prop="remark" label="备注信息" align="center">
      </el-table-column>
      <el-table-column prop="priority" label="优先级" sortable align="center">
      </el-table-column>
      <el-table-column prop="operator" label="操作人" align="center">
      </el-table-column>
      <el-table-column prop="mtime" label="修改时间" align="center" :formatter="formatDate">
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ scope.row.valid === 0 ? '下线' : '上线' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleCopy(scope.row)">复制</el-button>
          <el-button type="text" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button type="text" @click="handleChangeValid(scope.row)">{{
            scope.row.valid === 1 ? '下线' : '上线'
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <el-row>
      <el-pagination 
        background 
        layout="prev, pager, next" 
        :total="totalPage" 
        :page-size="pageSize"
        :current-page="currentPage" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'UserSignTable',
  props: {
    userSignList: {
      type: Array,
      default: () => []
    },
    totalPage: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 30
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  methods: {
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    handleCopy(row) {
      this.$emit('copy', row)
    },
    handleDelete(id) {
      this.$emit('delete', id)
    },
    handleChangeValid(row) {
      this.$emit('changeValid', row)
    },
    handleCurrentChange(page) {
      this.$emit('currentChange', page)
    }
  }
}
</script>

<style scoped lang="scss">
.user-sign-table {
  .el-pagination {
    margin-top: 20px;
    // text-align: center;
  }
}
</style> 